import { Link } from 'react-router-dom'
import './aboutUs.less'
import { InstagramOutlined, TwitterOutlined, FacebookOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import { Button } from 'antd';


export const AboutUs = () => {
    const intl = useIntl();
    return <div>
        <div className='news-banner-wrapper'>
            <img className='about-img' src="https://obs-pipishou.obs.cn-east-3.myhuaweicloud.com/SnailBicycle/SnailBicycl/course/16704800430027477.png" alt="" />
            <div className='news-banner-title'><span>{intl.formatMessage({id: 'about.title'})}</span></div>
        </div>
        <div className='about-wrapper'>
            {/* <div className='title'>{intl.formatMessage({id: 'about.Story'})}</div> */}
            <div className='title'>{intl.formatMessage({id: 'about.technology'})}</div>
            <div className='con font-bold '>{intl.formatMessage({id: 'about.Profile'})}</div>
            <div className='content'>{intl.formatMessage({id: 'about.Story.con1'})}</div>
            <div className='content'>{intl.formatMessage({id: 'about.Story.con2'})}</div>
            <div className='content'>{intl.formatMessage({id: 'about.join'})}</div>
            <div className='link-wrapper'>
                <a target={'_blank'} href="https://www.instagram.com/snailcle_world/"><Button type="primary" icon={<InstagramOutlined />} size={"large"}/></a>
                <a target={'_blank'} href="https://twitter.com/snailcleworld"><Button type="primary" icon={<FacebookOutlined />} size={"large"}/></a>
                <a target={'_blank'} href="https://www.facebook.com/search/top/?q=Hello%20Snailcle"><Button type="primary" icon={<TwitterOutlined />} size={"large"}/></a>
            </div>
            <ul className='info-list'>
                <li>
                    <span className='name'>{intl.formatMessage({id: 'about.phone'})}</span>
                    <span className='con font-bold'>0086 592 6261321 </span>
                </li>
                <li>
                    <span className='name'>{intl.formatMessage({id: 'about.email'})}</span>
                    <span className='con font-bold'>support@snailcle.com </span>
                </li>
                <li>
                    <span className='name'>{intl.formatMessage({id: 'about.address'})}</span>
                    <span className='con font-bold'>{intl.formatMessage({id: 'about.address.con'})}</span>
                </li>
            </ul>
        </div>
    </div>
}